<template>
  <div class="edit-profilebox">
    <ul class="breadcrumbs-list">
      <a href="javascript:void(0)" @click="backButton">
        <li>User Profile</li>
      </a>
      <li>&nbsp;>&nbsp;Edit Profile</li>
    </ul>
    <h4 class="welcome-text">Edit Profile</h4>
    <div class="edit-profile-content bg-dot-img">
      <div class="profile-picbox">
        <div class="profile-pic">
          <v-img width="150" height="150" :src="profile_image">
          </v-img>
          <label class="dp-change">
            <v-img max-height="40" max-width="40">
            </v-img>
            <input type="file" id="profile_pic" @change="profilePic" class="profile-change"
              accept="image/x-png,image/gif,image/jpeg" :key="componentKey"/>
          </label>
        </div>
      </div>
      <div class="edit-profilebox-detail">
        <form @submit.prevent class="login-form-box register-page" lazy-validation>
          <v-row>
            <v-col class="first-inputbox">
              <v-text-field v-model="full_name" :error-messages="fullNameErrors" label="Full Name*" required
                @input="$v.full_name.$touch()" @blur="$v.full_name.$touch()"></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" class="col">
              <v-container fluid>
                <div class="select-radiobox">
                  <label class="laberbox">Gender*</label>
                  <div>
                    <label class="container Female">
                      <input type="radio" checked="checked" name="radio" v-model="gender" value="female" />
                      <span class="checkmark">
                        Female
                      </span>
                    </label>
                    <label class="container male">
                      <input type="radio" checked="checked" name="radio" v-model="gender" value="male" />
                      <span class="checkmark">
                        Male
                      </span>
                    </label>
                    <label class="container other">
                      <input type="radio" checked="checked" name="radio" v-model="gender" value="others" />
                      <span class="checkmark">
                        Others
                      </span>
                    </label>
                  </div>
                </div>
              </v-container>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" md="12" class="col">
              <v-text-field v-model="email" :error-messages="emailErrors" label="Email Address*" required
                @input="$v.email.$touch()" @blur="$v.email.$touch()" readonly></v-text-field>
            </v-col>
            <v-col class="col mobile-box" cols="12" md="12">
              <v-col class="d-flex">
                <v-select disabled v-model="country_code" :items="items" filled dense solo></v-select>
              </v-col>
              <v-text-field class="pan-cardbox" v-model="phonenumber" :error-messages="phonenumberErrors"
                label="Mobile*" required @input="$v.phonenumber.$touch()" @blur="$v.phonenumber.$touch()" readonly>
              </v-text-field>
            </v-col>
          </v-row>

          <v-row>
            <v-col>
              <label style="display:flex;justify-content:space-between;margin-bottom:5px;">PAN <a href="javascript:void(0)"  v-on:click="showFullInfo('pancard')"
                  title="Show Full Pan Card Detail">Show/Edit</a></label>
              <v-text-field v-bind:class="{ 'pan-cardbox': isAddClass }" v-model="pancard" @input="customPanError"
                paceholder="Enter PAN" :disabled="is_pancard_disabled"></v-text-field>
              <span v-bind:class="{ 'error-messagebox-login': isAddClassServerError }" id="pan_side_error">{{ panError }}</span>
            </v-col>
          </v-row>

          <v-row v-if="masked_date !=''">
            <v-col class="dob-box">
              <label style="display:flex;justify-content:space-between;">DATE OF BIRTH <a href="javascript:void(0)" v-on:click="showFullInfo('dob')"
                  title="Show Full DOB Detail">Show/Edit</a></label>
                  <Datepicker v-model="date" format="dd MMM, yyyy" :disabledDates="disabledDates" @selected="verifyAge($event)" v-if="actual_dob_show"></Datepicker>
                  <v-text-field v-model="masked_date" disabled v-else></v-text-field>
            </v-col>
          </v-row>
          <v-row v-else>
            <v-col class="dob-box">
              <label style="display:flex;justify-content:space-between;">DATE OF BIRTH</label>
                <Datepicker v-model="date" format="dd MMM, yyyy" :disabledDates="disabledDates" @selected="verifyAge($event)"></Datepicker>
            </v-col>
          </v-row>
 
          <span v-bind:class="{
            'error-messagebox-login': isAddClassServerError
          }" id="server_side_error">{{ serverError }}</span>

          <v-row class="buttonbox">
            <v-btn class="blue-border-btn" @click="backbutton">
              Cancel
            </v-btn>
            <v-btn class="blue-btn" @click="submit" :disabled="!isFormValid" :error-messages="buttonErrorMessage" v-if="allow_user_activity =='yes'">
              save
            </v-btn>
          </v-row>
          <div class="sign-up-link login-link">
            <button @click="changePassword" type="button" class="btn btn-secondary">
              change password
            </button>
          </div>
        </form>
        <v-row justify="center">
          <v-dialog v-model="verify_otp_dialog_status" persistent max-width="290">
            <v-card cols="6">
              <v-card-title>
                <span class="text-h5">Verify Your Mobile</span>
              </v-card-title>
              <v-card-text>
                <v-container>
                  <v-form ref="form" id="verify_otp" v-model="valid" lazy-validation @submit.prevent>
                    <v-row>
                      <v-col>
                        <p style="font-size:13px;">We have send a verification code to registered mobile number ******{{mob_last_four}}<br>The code is valid for 5 minutes only.</p>
                        <!-- <v-otp-input v-model="otp"></v-otp-input> -->
                        <v-text-field name="otp" v-model="otp" ref="otp" placeholder="Enter OTP" autofocus></v-text-field>
                        <p style="color:red;" v-if="otp_error">{{ error_text }}</p>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="close">
                  Cancel
                </v-btn>
                <v-btn color="blue darken-1" text @click="verifyOtp">
                  Verify OTP
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <p class="warning-msg">
                  In case you don’t receive the OTP in the next 5 minutes, please press Resend button below.
                </p>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="resendOTP">
                  Resend OTP
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </div>
    </div>
  </div>

</template>
<script>
import moment from 'moment'
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { validationMixin } from "vuelidate";
import {
  required,
  email,
  minLength,
  sameAs,
  isAlphanumeric,
  alpha,
  numeric,
  maxLength
} from "vuelidate/lib/validators";
import { Auth } from "aws-amplify";
import { GET_PROFILE_DETAIL, UPDATE_USER_PROFILE_DETAIL, UPDATE_PROFILE_DETAIL, VERIFY_EMAIL_OTP, VERIFY_MOBILE_OTP } from "../store/actions.type";
import ApiService from "../api/api.service";
import JwtService from "./common/jwt.service";
export default {
  components: {
    Datepicker
  },
  mixins: [validationMixin],

  validations: {
    email: { required, email },
    date: { required },
    full_name: {
      required,
      maxLength: maxLength(50),
      validateAlpha: function (value) {
        const alpha_str = /^[a-zA-Z\-\s]+$/.test(value);
        return alpha_str;
      }
    },
    phonenumber: {
      required,
      numeric,
      maxLength: maxLength(10),
      minLength: minLength(10)
    },
  },

  data: () => ({
    full_name: "",
    gender: "",
    email: "",
    phonenumber: "",
    pancard: "",
    cognito_idp: "",
    profile_image: "",
    users: {},
    mob_last_four:'',
    submitted: false,
    isAddClass: false,
    isMobileNo: true,
    genderValidate: "",
    country_code: "+91",
    items: ["+91"],
    activePicker: null,
    date: null,
    menu: false,
    isFormValid: true,
    disabledDates: {
      from: new Date()
    },
    serverError: "",
    panError: "",
    isAddClassServerError: false,
    full_pancard: "",
    full_dob: "",
    actual_dob_show: false,
    actual_dob_show: false,
    verify_otp_dialog_status: false,
    getFormData: '',
    valid: null,
    otp_error: false,
    error_text: '',
    unmasking_field_type: '',
    masked_date: '',
    is_pancard_disabled:true,
    otp:"",
    componentKey:0,
    allow_user_activity:localStorage.getItem('allow_user_activity'),
    actual_pancard : "",
    updated_pancard:""
  }),

  watch: {
    menu(val) {
      val && setTimeout(() => (this.activePicker = "YEAR"));
    },
    pancard(val){
       this.pancard = val.toUpperCase();
       let panStr = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(this.pancard)
       if(panStr ==false){
        this.isAddClassServerError = true;
        this.isAddClass = false;
        let masked_pan_exists = val.includes("****")
        if(!masked_pan_exists){
          this.panError = 'Invalid PAN number.';
        }
        else{

        }
       }
       else{

          this.isAddClass = true;
          this.panError = '';
       }
      if(this.unmasking_field_type == 'pancard'){
        this.customPanError()
      }
    }

  },

  computed: {
    fullNameErrors() {
      const errors = [];
      this.serverError = "";
      if (!this.$v.full_name.$dirty) return errors;
      !this.$v.full_name.required && errors.push("Name is required");
      !this.$v.full_name.maxLength &&
        errors.push("Name can't be greater than 50 characters");
      !this.$v.full_name.validateAlpha &&
        errors.push("Full name must be alphabet");
      return errors;
    },
    emailErrors() {
      const errors = [];
      this.serverError = "";
      if (!this.$v.email.$dirty) return errors;
      !this.$v.email.email && errors.push("Must be valid e-mail");
      !this.$v.email.required && errors.push("E-mail is required");
      return errors;
    },
    phonenumberErrors() {
      const errors = [];
      this.serverError = "";
      if (!this.$v.phonenumber.$dirty) return errors;
      !this.$v.phonenumber.required &&
        errors.push("Mobile Number required");
      !this.$v.phonenumber.numeric &&
        errors.push("Mobile Number must be numeric");
      !this.$v.phonenumber.minLength &&
        errors.push("Mobile Number must be 10 digit");
      !this.$v.phonenumber.maxLength &&
        errors.push("Mobile Number must be 10 digit");
      return errors;
    },
    buttonErrorMessage() {
      if (this.$v.$invalid) {
        this.isFormValid = false;
      } else if (!this.full_name) {
        this.isFormValid = false;
      } else if (this.full_name.length > 50) {
        this.isFormValid = false;
      } else if (!this.$v.full_name.validateAlpha) {
        this.isFormValid = false;
      } else if (this.email && !this.$v.email.email) {
        this.isFormValid = false;
      } else if (this.phonenumber && (!this.$v.phonenumber.numeric || !this.$v.phonenumber.minLength || !this.$v.phonenumber.maxLength)) {
        this.isFormValid = false;
      } else if (this.panError) {
        this.isFormValid = false;
      } else {
        this.isFormValid = true;
      }
    }
  },
  mounted() {
    Fire.$emit("picRefresh1");
  },

  created() {
    Fire.$on("picRefresh1", () => {
      this.getProfileData();
    });
  },

  methods: {
    customPanError() {
      let panStr = /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(this.pancard)
      
      if (this.pancard == "") {
        this.panError = '';
      } else if (panStr) {
        this.isAddClass = true;
        this.panError = '';
      }
      else {
        this.isAddClassServerError = true;
        this.isAddClass = false;
        this.panError = 'Invalid PAN number.';
      }
    },
    save(date) {
      this.$refs.menu.save(date);
    },

    submit(e) {
      this.submitted = true;
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      this.$loading(true);
      if(this.pancard.includes("***") == true){
        this.updated_pancard = this.actual_pancard
      }
      else{
         this.updated_pancard = this.pancard
        
      }
      Auth.updateUserAttributes(this.users, {
        "custom:name": this.full_name,
        "custom:gender": this.gender,
        "custom:phonenumber": "+91" + this.phonenumber,
        "custom:pancard": this.updated_pancard ? this.updated_pancard : '',
        // "custom:birth": this.$moment(this.date).format('DD MMM, YYYY')
        "custom:birth": this.date,
      })
        .then(response => {
          let updatedDetail = [
            { key: 'user_name', value: this.full_name },
            { key: 'mobile_no', value: "+91" + this.phonenumber },
          ];
          this.$store.dispatch(UPDATE_PROFILE_DETAIL, updatedDetail)
          let cognito_idp = atob(localStorage.getItem('cognito_idp'));
          ApiService.setHeader();
          ApiService.post('update-user-profile-detail', {
            aws_cognito_id: cognito_idp,
            is_dob_update: 'yes',
          }).then((response) => {
            this.$store.dispatch(GET_PROFILE_DETAIL, {
              data: {
                aws_cognito_id: cognito_idp,
              },
              api: 'get-profile-detail',
            });
          })

          // Fire.$emit("profileUpdate");
          Fire.$emit("picRefresh1", this.$store.getters.getProfileDetail.data.photo);
          setTimeout(() => {
            this.$loading(false);
            if (this.$route.params.isback) {
              this.$router.push({ name: "Investometer" }).catch(() => { });
            }
            else {
              this.$router.push({ name: "dashboard" }).catch(() => { });
            }
          }, 1500);
        })
        .catch(err => {
          this.isAddClassServerError = true;
          if (
            err.message ==
            "Attribute value for custom:gender must not be null"
          ) {
            this.serverError = "Please select gender";
          }
          this.$loading(false);
        });
    },
    changePassword(evt) {
      evt.preventDefault();
      this.$router.push({ name: "Changepassword" }).catch(() => { });
    },
    backbutton(evt) {
      this.$router.push({ name: "dashboard" }).catch(() => { });
    },
    profilePic(evt) {
      var temp_pic = "";
      var file = document.getElementById("profile_pic");
      var reader = new FileReader();
      if (evt.target.files && evt.target.files[0]) {
        if (!evt.target.files[0].type.includes("image")) {
          swal.fire({
            title: 'Invalid File',
            text: "Only images are allowed.",
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          });
          this.componentKey++;
          file.value = '';
        }
        else if (evt.target.files[0]['size'] > 1024 * 1024) {
          swal.fire({
            title: 'Image Size',
            text: "Image can't be greater than 1MB",
            icon: 'warning',
            showCancelButton: false,
            confirmButtonColor: '#051d42',
            confirmButtonText: 'OK',
          }).then((result) => {
            if (result.isConfirmed) {

            }
          })
        }
        else {
          reader.onload = e => {
            this.$loading(true);
            this.$store.dispatch(UPDATE_USER_PROFILE_DETAIL, {
              data: {
                aws_cognito_id: atob(localStorage.getItem('cognito_idp')),
                profile_image: e.target.result,
              },
              api: 'update-user-profile-detail',
            }).then(() => {
              let response = this.$store.getters.getUpdateUserProfileDetail.data;
              this.$loading(false);
              if (response.status == 'error') {
                return [];
              } else {
                this.profile_image = response.photo;
                let updatedDetail = [
                  { key: 'photo', value: response.photo },
                ]
                this.$store.dispatch(UPDATE_PROFILE_DETAIL, updatedDetail)
                Fire.$emit("picRefresh1", response.photo);
              }
            })
            this.renderComponent = false;

            this.$nextTick(() => {
              // Add the component back in
              this.renderComponent = true;
            });
          };
          reader.readAsDataURL(file.files[0]);

        }
      }
    },
    backButton() {
      this.$router.push({ name: "dashboard" }).catch(() => { });
    },
    getProfileData() {
      if (this.$store.getters.getProfileDetail.data != undefined) {
        Auth.currentAuthenticatedUser({
          bypassCache: false
        })
          .then(user => {
            this.users = user;
            this.cognito_idp = atob(localStorage.getItem('cognito_idp'));
            this.full_name = this.users.attributes["custom:name"];
            this.gender = this.users.attributes["custom:gender"];
            this.email = this.users.attributes.email;
            this.phonenumber = this.users.attributes[
              "custom:phonenumber"
            ].replace("+91", "");
            if(this.users.attributes["custom:pancard"] ==undefined){
               this.is_pancard_disabled= false
            }
            
            

            this.full_pancard = this.users.attributes["custom:pancard"];
            this.full_dob = this.users.attributes["custom:birth"];
            this.pancard = (typeof this.users.attributes["custom:pancard"] != 'undefined')?this.users.attributes["custom:pancard"].substring(0, 4) + '******':'';
            this.actual_pancard = (typeof this.users.attributes["custom:pancard"] != 'undefined')?this.users.attributes["custom:pancard"]:'';

            if(this.users.attributes["custom:birth"] == 'Invalid date' || this.users.attributes["custom:birth"] =='' || this.users.attributes["custom:birth"] ==undefined){
              this.date = '';
              this.masked_date = '';
            }
            else{
              this.date = this.users.attributes["custom:birth"];
              this.masked_date = moment(this.users.attributes["custom:birth"]).format('DD MMM') + ', ****';
            }
              
          })
          .catch(err => {
            this.$router.push({ name: "Login" }).catch(() => { });
          });
        this.pancard ? this.isAddClass = true : this.isAddClass = false;
        this.profile_image = this.$store.getters.getProfileDetail.data.photo;
      }
    },

    showFullInfo(type) {
      this.otp_error = false
      this.otp = ''
      this.unmasking_field_type = type
      this.$store.dispatch(VERIFY_EMAIL_OTP, {
        data: {
          mobile_no:this.$store.getters.getUserDetails.mobile_no,
          aws_cognito_id: localStorage.getItem('cognito_idp'),
        },
        api: 'send-otp',
      }).then(() => {
        this.verify_otp_dialog_status = true
        this.mob_last_four=this.$store.getters.getUserDetails.mobile_no.substr(9);
      });
    },

    resendOTP() {
      this.$store.dispatch(VERIFY_EMAIL_OTP, {
        data: {
          mobile_no:this.$store.getters.getUserDetails.mobile_no,
          aws_cognito_id: localStorage.getItem('cognito_idp'),
        },
        api: 'send-otp',
      });
    },

    verifyOtp() {
      this.getFormData = document.querySelector("#verify_otp");
      if (this.otp != '') {
        let formdata = new FormData();
        formdata.append("aws_cognito_id", localStorage.getItem('cognito_idp'));
        formdata.append("otp", this.otp);
        formdata.append("mobile_no", this.$store.getters.getUserDetails.mobile_no);
        axios.post(process.env.VUE_APP_ROOT_API + 'verify-otp', formdata).then((res) => {
          if (res.data.status == 'error') {
            this.otp_error = true
            this.error_text = 'Wrong OTP.'
          }
          else {
            this.otp = '';
            if (this.unmasking_field_type == 'pancard') {
              this.is_pancard_disabled = false
              this.pancard = this.full_pancard
            }
            else if (this.unmasking_field_type == 'dob') {
              this.actual_dob_show = true
            }
            this.verify_otp_dialog_status = false
            this.otp_error = false
          }
        }).catch(() => {

        });
      }
      else {
        this.otp_error = true
        this.error_text = 'OTP Required.'
      }
    },

    close() {
      this.verify_otp_dialog_status = false
      
    },

    verifyAge(dob){
     
      let year_diff  =  moment(moment(moment()).format('DD-MM-YYYY'), 'DD-MM-YYYY').diff( moment(moment(dob).format('DD-MM-YYYY'), 'DD-MM-YYYY'), 'year');
      if(year_diff < 18){
        swal.fire({icon:'warning',title:"Age must be greater than 18 years"}); 
        this.date = '';
        this.isFormValid = false
      }
      else{
        this.isFormValid = true 
      }
    }
  }
};
</script>
<style scoped>
.edit-profile-content .pan-cardbox {
    margin-top: 7px !important;
}

.edit-profile-content .mobile-box .pan-cardbox {
    margin-top: 0px !important;
}

.edit-profile-content .pan-cardbox::before {
    top: 17px;
}

.edit-profile-content .mobile-box .pan-cardbox::before {
    top: 42px;
}
</style>
